<template>
    <div class="login__tvp">
        <p class="login__title">Zaloguj się, do konta TVP</p>

        <form class="login__form">
            <div class="login__form-item">
                <label for="email" class="login__label">E-mail:</label>
                <input v-model="email" id="email" type="text" class="login__input" placeholder="wpisz twój e-mail" />
                <small class="errors" v-if="loginData && loginData.data && loginData.data.fields">
                    <span v-if="loginData.data.fields && loginData.data.fields.email">
                        {{ loginData.data.fields.email[0] }}
                    </span>
                </small>
            </div>

            <div class="login__form-item">
                <label for="name" class="login__label">Hasło:</label>
                <input v-model="password" id="name" type="password" class="login__input" autocomplete="on" placeholder="wpisz twoje hasło" />
                <small class="errors" v-if="loginData && loginData.data && loginData.data.fields">
                    <span v-if="loginData.data.fields && loginData.data.fields.password">
                        {{ loginData.data.fields.password[0] }}
                    </span>
                </small>
            </div>

            <a href="https://user.tvp.pl/passwordreset.php?mode=normal" @click="resetPassword = true" class="login__remind">Zapomniałem(am) hasła</a>

            <span class="errors" v-if="loginData && loginData.data && !userData.email">
                <span v-if="loginData.data.form">{{ loginData.data.form.error[0] }}</span>
            </span>

            <button class="btn" @click.prevent="login"><span>Zaloguj się</span></button>
        </form>

        <template v-if="!getPinLock || !getPinLock.isOpen">
            <p class="login__noaccount" @click="register">Nie masz konta w TVP?</p>
            <a :href="urlToRegister" class="login__register">Załóż konto</a>
        </template>
    </div>
</template>

<script>
import { getSubProfilesList } from '@/mixins/getSubProfilesList';
import { sha256 } from 'js-sha256';
import { useCookies } from "vue3-cookies";
import globalDataLayer from '../../mixins/globalDataLayer';
const { cookies } = useCookies();

export default {
    name: "LoginTVP",
    data() {
        return {
            email: '',
            password: '',
            token: '7yF1Xrp2gC3i4tBYY5DSdO5chK9eXnNk',
            redirects: {
                addProfile: {
                    name: 'ProfileStart',
                    path: '/dodaj-profil'
                },
                selectProfile: {
                    name: 'ProfileSelect',
                    path: '/wybierz-profil'
                },
                settings: {
                    name: 'AccountSettings',
                    path: '/ustawienia'
                },
                account: {
                    name: 'Account',
                    path: '/strefa-rodzica'
                }                              
            },
            SUBPROFILES: '/api/krainaabc/subprofile/list?device=www'     
        };
    },
    mixins: [globalDataLayer],
    watch: {
        loginData() {
            if(this.loginData && this.loginData.status !== 200) {
                this.loginError(this.loginData.status);
            } 

            if(this.loginData && this.loginData.status == 200) {
                this.$store.dispatch('userinfo');
                this.$store.dispatch('globalUserData');
                this.$store.dispatch("changeModalLoginState");
                this.$store.dispatch("changeModalBackdrop", false);

                if(this.getPinLock && this.getPinLock.isOpen) {
                    if(this.getPinLock.mode === 'unlock' || this.getPinLock.mode === 'remind') {
                        this.$router.push(this.redirects.settings);
                        this.$store.dispatch("changePinLock", { isOpen: false, mode: this.getPinLock.mode, path: this.getPinLock.path });
                    } else if(this.getPinLock.mode === 'access') {
                        this.$router.push(this.redirects.account);
                        this.$store.dispatch("changePinLock", { isOpen: false });
                    }
                    
                    cookies.remove("parent_lock");
                } else {
                    this.checkSubProfileList();
                    this.$store.dispatch("changeIsLoggedIn"); 
                }

                this.loginFinish();
            }            
        }
    },
    computed: {
        loginData() {
            return this.$store.getters.getLoginData;
        },
        userData() {
            return this.$store.getters.getUserData;
        },
        urlToRegister() {
            return `https://user.tvp.pl/register.php?ref=${this.generateHash()}&src=krainaabc&mode=normal`;
        },
        getPinLock() {
            return this.$store.getters.getPinLock;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        login() {
            if(this.loginData && this.loginData.status === 200) {
                this.loginFinish();
            }
            this.$store.dispatch('login', {
                email: this.email,
                password: this.password,
                token: sha256(this.email + this.password + this.token),
            });
        },
        generateHash() {
            return window.btoa(window.location.origin + '/strefa-rodzica') || '';
        },
        async checkSubProfileList() {
            const subProfilesList = await getSubProfilesList();

            if(subProfilesList && subProfilesList.length) {
                this.$router.push(this.redirects.selectProfile);
            } else {
                this.$router.push(this.redirects.addProfile);
            }
        }
    },
    mounted() {
        window.gemius_event(
            '_action_',
            this.gemiusIdentifier,
            'event=modalLogin'
        );
    }
};
</script>